<template>
  <div :style="{ 'max-height': tableHeight + 'px' }">
    <v-data-table
      small
      :no-data-text="$tc('editRegistrations.notData')"
      show-select
      fixed-header
      class="mt-1"
      :single-select="singleSelect"
      v-model="selecLocal"
      :headers="headers"
      :items="items"
      :search="search"
      item-key="movimId"
      :hide-default-footer="true"
      disable-pagination
      :loading-text="$tc('editRegistrations.loadingItems')"
      :loading="loader"
      :height="tableHeight"
    >
      <template v-slot:item.actions="{ item }">
        <div style="display: flex; flex-direction: row">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <div class="center">
                  <v-icon
                    small
                    color="accent"
                    class="mt-2"
                    @click="openApproved(item)"
                    v-show="pendings"
                  >
                    fa-thumbs-up
                  </v-icon>
                </div>
              </span>
            </template>
            <span>{{ $tc("workflow.approved") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <div class="center">
                  <v-icon
                    small
                    color="accent"
                    class="mt-2 ml-3"
                    @click="openDeprecated(item)"
                    v-show="pendings"
                  >
                    fa-thumbs-down
                  </v-icon>
                </div>
              </span>
            </template>
            <span>{{ $tc("workflow.reject") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <div class="center">
                  <v-icon
                    small
                    color="accent"
                    class="mt-2 ml-3"
                    @click="openAction(item)"
                    v-show="!pendings"
                  >
                    fa-arrow-left
                  </v-icon>
                </div>
              </span>
            </template>
            <span>{{ $tc("workflow.undo") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <div class="center">
                  <v-icon
                    small
                    color="accent"
                    class="mt-2 ml-3"
                    @click="openFiles(item)"
                  >
                    fa-file
                  </v-icon>
                </div>
              </span>
            </template>
            <span>{{ $tc("workflow.seeAttachedDocuments") }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import activities from "../../../store/workflow/activities";
export default {
  props: {
    headers: Array,
    items: Array,
    openAction: Function,
    loader: Boolean,
    search: String,
    itemsPerPage: Number,
    openDeprecated: Function,
    openApproved: Function,
    openFiles:Function
  },
  data() {
    return {
      singleSelect: false,
      tableHeight: this.calculateMaxHeight(),
    };
  },
  computed: {
    selecLocal: {
      get() {
        return activities.state.itemsSelected;
      },
      set(value) {
        activities.commit("setItemsSelected", value);
        return value;
      },
    },
    pendings() {
      return activities.state.changeEvent;
    },
  },
  methods: {
    calculateMaxHeight() {
      const windowHeight = window.innerHeight;
      // Define multipliers for different window height ranges
      const lowMultiplier = 0.5; // Multiplier for window heights less than 1000 pixels
      const highMultiplier = 0.65; // Multiplier for window heights 1000 pixels or greater

      // Determine multiplier based on window height
      let multiplier = lowMultiplier;
      if (windowHeight >= 1000) {
        multiplier = highMultiplier;
      }

      // Calculate maximum height based on multiplier
      const maxHeight = windowHeight * multiplier;
      return maxHeight;
    },
    updateTableHeight() {
      this.tableHeight = this.calculateMaxHeight();
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
  },
};
</script>

<style scoped>
::v-deep .v-data-table-header th {
  background-color: #82a1d0 !important;
}

::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
